import React from "react";
import { Typography } from "@mui/material";
import { getMetricTimeStamp } from "../../../../../Helper/DatePicker/DateConverter";
import { FilterBoxTooltip } from "../../TableStyles";
import dayjs from "dayjs";


const Timestamp = ({ config, record }) => {
	let value = record?.[config?.dataIndex];

	if (value == '0000-00-00 00:00:00') {
		value = null
	}


	let dateFormat = config.dateFormat ? config.dateFormat : "DD MMM'YY hh:mm A"
	let defaultValue = config.defaultValue ? config.defaultValue : "Not Available"
	let tooltipDateFormat = config.tooltipDateFormat ? config.tooltipDateFormat : "DD MMM'YY hh:mm A"

	// disableTimezone defaults to false (timezone conversion enabled by default)
	// Set to true to bypass timezone conversion and format the date as-is
	const disableTimezone = config.disableTimezone !== undefined ? config.disableTimezone : false;

	let columnDate = defaultValue;
	let tooltipDate = defaultValue;

	if (value) {
		if (disableTimezone) {
			// Format date without timezone conversion
			columnDate = dayjs(value, "YYYY-MM-DD HH:mm:ss").format(dateFormat);
			tooltipDate = dayjs(value, "YYYY-MM-DD HH:mm:ss").format(tooltipDateFormat);
		} else {
			// Apply timezone conversion (default behavior)
			columnDate = getMetricTimeStamp(value, dateFormat);
			tooltipDate = getMetricTimeStamp(value, tooltipDateFormat);
		}
	}

	return (
		<FilterBoxTooltip title={tooltipDate} placement={'bottom'}>
			<Typography variant="fw400s14lh24c3D4B5A">{columnDate}</Typography>
		</FilterBoxTooltip>
	);
};

export default Timestamp
